/* Environment Map — Mini-map overview component */
import { HEALTH_COLORS } from './constants';

export function MiniMap({ nodes, edges, positions, nodeIndex, viewBox, canvasW, canvasH, onPan, visibleNodeIds }) {
  var MINI_W = 160, MINI_H = 80;
  var vbParts = viewBox.split(' ').map(Number);

  function handleClick(e) {
    var rect = e.currentTarget.getBoundingClientRect();
    var mx = ((e.clientX - rect.left) / rect.width) * canvasW;
    var my = ((e.clientY - rect.top) / rect.height) * canvasH;
    onPan(mx - vbParts[2] / 2, my - vbParts[3] / 2);
  }

  return (
    <div className="absolute bottom-2 right-2 z-20 border border-kova-cyan/12 bg-kova-bg/90 backdrop-blur-sm" data-testid="mini-map" style={{ width: MINI_W, height: MINI_H, cursor: 'crosshair' }} onClick={handleClick}>
      <svg width={MINI_W} height={MINI_H} viewBox={'0 0 ' + canvasW + ' ' + canvasH}>
        {edges.map(function (e) {
          var si = nodeIndex[e.source_node_id], ti = nodeIndex[e.target_node_id];
          if (si == null || ti == null || !positions[si] || !positions[ti]) return null;
          return <line key={e.edge_id} x1={positions[si].x} y1={positions[si].y} x2={positions[ti].x} y2={positions[ti].y} stroke="rgba(10,191,163,0.12)" strokeWidth={8} />;
        })}
        {nodes.map(function (n, i) {
          if (!positions[i] || !visibleNodeIds.has(n.node_id)) return null;
          var c = n.is_critical_path ? '#FFD700' : HEALTH_COLORS[n.health_status] || '#3D5A70';
          return <circle key={n.node_id} cx={positions[i].x} cy={positions[i].y} r={12} fill={c} />;
        })}
        <rect x={vbParts[0]} y={vbParts[1]} width={vbParts[2]} height={vbParts[3]} fill="none" stroke="#0ABFA3" strokeWidth={10} />
      </svg>
    </div>
  );
}
